import { AssetAWDto } from '@api/Api';

export const statuses = {
  skipped: 'Skipped',
  pending: 'In Review',
  in_progress: 'In Review',
  approved: 'Approved',
  approved_with_feedback: 'Approved with feedback',
  changes_required: 'Changes required'
};

export function statusToCopy(aw: AssetAWDto) {
  if (!aw) return '';
  if (aw.isPaused) return 'Paused';

  return statuses[aw.status];
}
